enum ContactUsFormFieldEnum {
	WHAT_BEST_DESCRIBES_YOU = 'ct_us_frm_hch_wbd',
	HOW_CAN_WE_HELP_PARTNER = 'ct_us_frm_hch_help_part',
	HOW_CAN_WE_HELP_SUPPORT = 'ct_us_frm_hch_help_sup',
	HOW_CAN_WE_HELP_SE = 'ct_us_frm_hch_help_se',
	WHICH_TOOLKIT_WOULD_YOU_LIKE_TO_RECEIVE = 'ct_us_frm_hch_toolkit',
	WHICH_ARE_YOU_LOOKING_AT_IN_PARTICULAR = 'ct_us_frm_hch_looking_at',
	SALUTATION = 'salutation',
	FIRST_NAME = 'firstname',
	LAST_NAME = 'lastname',
	COMPANY_NAME = 'company',
	DESIGNATION = 'ct_us_frm_designation',
	OTHER_DESIGNATION = 'other_designation',
	COUNTRY_OF_OPERATION = 'ct_us_frm_ct_details_country',
	BUSINESS_SECTOR = 'business_sector',
	WHERE_IS_YOUR_BUSINESS_ON_ITS_SOCIAL_IMPACT_JOURNEY = 'ct_us_frm_ct_details_impact',
	EMAIL = 'email',
	PHONE_NUMBER = 'phone',
	UEN = 'uen_number',
	BUSINESS_WEBSITE = 'website',
	ORGANIZATION_TYPE = 'ct_us_frm_gen_orgtyp',
	YOUR_ENQUIRY = 'ct_us_frm_ct_details_enquiry',
	WHERE_DID_YOU_FIRST_HEAR_ABOUT_RAISE = 'ct_us_frm_ct_details_ref',
	SIGN_ME_UP = 'ct_us_frm_gen_newsletter',
	AGREE_POLICY = 'ct_us_frm_gen_privacy',
}

enum ContactUsConditionalValue {
	REQUEST_TOOLKIT = 'request_toolkit',
	LEARN_ABOUT_PROGRAMME_FUND = 'learn_about_programme_fund',
}

export { ContactUsFormFieldEnum, ContactUsConditionalValue };
